import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {collection, doc, getDoc, getDocs, updateDoc} from 'firebase/firestore';
import {fireStore} from '../../firebaseConfig';

const UpdateVehicle = () => {
    const {id} = useParams();
    const navigate = useNavigate();
    const [vehicleData, setVehicleData] = useState({
        name: '',
        regNumber: '',
        year: '',
        color: '',
        engine: '',
        make: '',
        meterReading: '',

    });
    const [loading, setLoading] = useState(true);
    const [signupRequests, setSignupRequests] = useState([]);
    const [selectedUserDetails, setSelectedUserDetails] = useState(null);
    const [userName, setUserName] = useState('');
    const [userTerritory, setUserTerritory] = useState('');
    const [userZone, setUserZone] = useState('');
    const [userRole, setUserRole] = useState('');
    const [userPhone, setUserPhone] = useState('');
    const fetchApprovedSignupRequests = async () => {
        try {
            const collectionRef = collection(fireStore, 'SignupRequests'); // Reference to the Firestore collection
            const querySnapshot = await getDocs(collectionRef);

            // Log all data from the collection
            const allRequestsList = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            console.log('All Signup Requests:', allRequestsList); // Log all signup requests

            // Filter to get only approved requests
            const approvedRequestsList = allRequestsList.filter(request => request.approved); // Only keep approved requests

            console.log('Approved Signup Requests:', approvedRequestsList);
            setSignupRequests(approvedRequestsList);
        } catch (error) {
            console.error('Error fetching signup requests:', error);
        }
    };
    useEffect(() => {
        fetchApprovedSignupRequests(); // Fetch the requests when the component mounts
    }, []);

    const handleSelectChange = (event) => {
        const selectedIndex = event.target.selectedIndex - 1; // -1 to account for the placeholder option
        if (selectedIndex >= 0) {
            const selectedUser = signupRequests[selectedIndex];
            setSelectedUserDetails(selectedUser);

            // Set user-related state variables based on the selected user
            setUserName(selectedUser.user.name); // Assuming selectedUser has user property with name
            setUserPhone(selectedUser.user.phone || ''); // Handle cases where phone might be undefined
            setUserTerritory(selectedUser.user.territory?.name || 'N/A'); // Optional chaining
            setUserZone(selectedUser.user.zone || 'N/A'); // Optional chaining
            setUserRole(selectedUser.user.role || 'N/A'); // Optional chaining
        } else {
            // Reset state variables if no valid user is selected
            setSelectedUserDetails(null);
            setUserName('');
            setUserPhone('');
            setUserTerritory('');
            setUserZone('');
            setUserRole('');
        }
    };

    useEffect(() => {
        const fetchVehicle = async () => {
            try {
                const vehicleDoc = doc(fireStore, 'Vehicles', id); // Reference to the document
                const docSnap = await getDoc(vehicleDoc);

                if (docSnap.exists()) {
                    setVehicleData(docSnap.data()); // Set the vehicle data
                } else {
                    console.log("No such document!");
                }
            } catch (error) {
                console.error("Error fetching document:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchVehicle();
    }, [id]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setVehicleData((prevData) => ({
            ...prevData,
            [name]: name === 'meterReading' ? parseFloat(value) : value,
        }));
    };

    // const handleInputChange = (e) => {
    //     const {name, value} = e.target;
    //     setVehicleData({...vehicleData, [name]: value});
    // };
    const handleUpdateVehicle = async () => {
        try {
            const vehicleDocRef = doc(fireStore, 'Vehicles', id);

            // Prepare updated data
            const updatedVehicleData = {
                ...vehicleData,
                user: {
                    name: userName,
                    phone: userPhone,
                    territory: userTerritory,
                    zone: userZone,
                    role: userRole
                }
            };

            // Update the vehicle document in Firestore
            await updateDoc(vehicleDocRef, updatedVehicleData);

            alert('Vehicle updated successfully!');
            navigate('/vehicles'); // Navigate back to the vehicles list
        } catch (error) {
            console.error('Error updating vehicle:', error);
        }
    };


    if (loading) {
        return <p>Loading...</p>;
    }

    console.log('vehicleData', vehicleData);
    return (
        <div className="p-4 bg-lightgray">
            <div className="max-w-full mx-auto bg-white p-10 rounded-lg shadow-lg" >
                <div className="flex flex-col md:flex-row justify-between items-center">
                    <h2 className="text-xl font-semibold ml-4 mb-4 md:mb-0 font-lato text-liquidblue">UPDATE VEHICLES</h2>
                </div>
                <div className="bg-white p-4 mb-4 h-[500px] overflow-y-scroll">
                    <div className="p-10  mb-4 bg-white rounded-lg shadow-lg border border-gray-200">
                        <div className="flex space-x-8 p-6">


                            <div className="w-full md:w-1/2">
                                <h2 className="text-center font-semibold text-lg text-darkgreen mb-4">Vehicle
                                    Details</h2>
                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-sm text-lightbrown">Vehicle Name</label>
                                        <input
                                            type="text"
                                            placeholder="Vehicle Name"
                                            name="name"
                                            value={vehicleData.name}
                                            onChange={handleInputChange}
                                            className="mt-1 block w-full px-3 py-1.5 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:border-teal-500"/>
                                    </div>
                                    <div>
                                        <label className="block text-sm text-lightbrown">Registration Number</label>
                                        <input type="text" placeholder="Registration Number"
                                               name="regNumber"
                                               value={vehicleData.regNumber} onChange={handleInputChange}
                                               className="mt-1 block w-full px-3 py-1.5 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:border-teal-500"/>
                                    </div>
                                    <div>
                                        <label className="block text-sm text-lightbrown">Year of Manufacturing</label>
                                        <input type="text" placeholder="Year of Manufacturing" value={vehicleData.year}
                                               name="year" onChange={handleInputChange}
                                               className="mt-1 block w-full px-3 py-1.5 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:border-teal-500"/>
                                    </div>
                                    <div>
                                        <label className="block text-sm text-lightbrown">Color</label>
                                        <input type="text" placeholder="Color" value={vehicleData.color} name="color"
                                               onChange={handleInputChange}
                                               className="mt-1 block w-full px-3 py-1.5 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:border-teal-500"/>
                                    </div>
                                    <div>
                                        <label className="block text-sm text-lightbrown">Engine Power</label>
                                        <input type="text" placeholder="Engine Power" value={vehicleData.engine}
                                               name="engine" onChange={handleInputChange}
                                               className="mt-1 block w-full px-3 py-1.5 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:border-teal-500"/>
                                    </div>
                                    <div>
                                        <label className="block text-sm text-lightbrown">Make</label>
                                        <input type="text" placeholder="Make" value={vehicleData.make} name="make"
                                               onChange={handleInputChange}
                                               className="mt-1 block w-full px-3 py-1.5 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:border-teal-500"/>
                                    </div>
                                </div>
                            </div>

                            <div className="w-full md:w-1/2 ">
                                <h2 className="text-center font-semibold text-lg text-darkgreen mb-4">User</h2>
                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-sm text-lightbrown">Current Meter Reading</label>
                                        <input type="number" placeholder="Current Meter Reading" name="meterReading"
                                               value={vehicleData.meterReading} onChange={handleInputChange}
                                               className="mt-1 block w-full px-3 py-1.5 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:border-teal-500"/>
                                    </div>
                                </div>
                                <div>
                                    <div className="mb-10">
                                        <label className="block text-sm text-lightbrown mt-4">User</label>
                                        <select onChange={handleSelectChange}
                                                className="mt-1 block w-full px-3 py-1.5 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:border-teal-500">
                                            <option value="">Select User</option>
                                            {signupRequests.map((request) => (
                                                <option key={request.id} value={request.user.name}>
                                                    {request.user.name}
                                                </option>
                                            ))}
                                        </select>

                                    </div>
                                    {selectedUserDetails && (
                                        <div className="text-gray-700 text-sm space-y-1">
                                            <div className="space-y-1">
                                                <label className="font-bold text-md">Phone :</label>
                                                <p className='text-gray-400'>{selectedUserDetails.user?.phone || 'N/A'}</p>
                                            </div>
                                            <div className="space-y-1">
                                                <label className="font-bold text-md">Territory :</label>
                                                <p className='text-gray-400'>{selectedUserDetails.user?.territory?.name || 'N/A'}</p>
                                            </div>
                                            <div className="space-y-1">
                                                <label className="font-bold text-md">Zone :</label>
                                                <p className='text-gray-400'>{selectedUserDetails.user?.zone || 'N/A'}</p>
                                            </div>
                                            <div className="space-y-1">
                                                <label className="font-bold text-md">Deignation :</label>
                                                <p className='text-gray-400'>{selectedUserDetails.user?.role || 'N/A'}</p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="flex justify-center mt-8">
                            <button onClick={handleUpdateVehicle}
                                    className="bg-teal-600 hover:bg-teal-700 text-white font-semibold py-2 px-20 rounded-md">Update
                            </button>
                        </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default UpdateVehicle;
